export enum InitializingStatusEnums {
    /**
     * Object is not initialized
     */
    NOT_INITIALIZED = 0,
    /**
     * Initializing in progress
     */
    INITIALIZING = 1,
    /**
     * Object is initialized
     */
    INITIALIZED = 2,
}
